import { useEffect } from "react";
import { setSnapshot } from "../state/signup.action";


/**
 * Handles the snapshotting of data after each state update
 * When someone drops off we want them to resume from where they left off
 */
export function useSnapshot<T>(dispatch: any, key: string, state: T, snapshotCheck?: (state: T) => void, isDisabled?: boolean) {

    useEffect(() => {
        const snapshot = loadSnapshot(key);
        if (snapshot) {
            if (snapshotCheck) {
                snapshotCheck(snapshot);
            }
            dispatch(setSnapshot(snapshot));
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (state && !isDisabled) {
            takeSnapshot(key, state);
        }
        // eslint-disable-next-line
    }, [key, state]);

    function _removeSnapshot() {
        removeSnapshot(key);
    }
    return { removeSnapshot: _removeSnapshot };
}

export function takeSnapshot<T>(key: string, state: T) {
    localStorage.setItem(key, JSON.stringify(state));
}

export function loadSnapshot(key: string) {
    const snapshot = localStorage.getItem(key);
    try {
        if (snapshot) return JSON.parse(snapshot);
    } catch (error) {
        /**Don't care about the error */
    }
    return null;
}

export function removeSnapshot(key: string) {
    localStorage.removeItem(key);
}